/** Everything flagged, worst first. */
import { useApp } from '../store/AppContext.jsx';
import StatCards from '../components/StatCards.jsx';
import QueueCard from '../components/QueueCard.jsx';
import BreakdownCard from '../components/BreakdownCard.jsx';

export default function NeedsAction() {
  const { S } = useApp();
  return (
    <>
      <StatCards view="queue" />
      {/* Stacked, not side by side. The queue is the page: its rows carry a
          name, a reason and two actions, and a 360px column truncated all
          three. Breakdown sits underneath at full width, which is also what
          lets its four panels sit two to a row with readable labels. */}
      <QueueCard limit={S.queueMax || 60} />
      <BreakdownCard />
    </>
  );
}
